var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.fetching ? _c('div', [_c('PageTitle', [_vm._v(_vm._s(_vm.group.name || '群組名稱'))]), _c('p', {
    staticClass: "s-mb-10"
  }, [_vm._v("尚未設定群組網址")]), _c('a', {
    staticClass: "s-btn s-btn-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("確認")])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }